module.exports = __webpack_public_path__ + "static/img/004-ban-1.d51a6e44.jpg";